export default "__VITE_ASSET__DWFGusnW__"